import { ChangeEventHandler, ElementType, MouseEvent } from 'react';

import { TablePaginationTypeMap } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

import TableActions from '../components/table-actions/TableActions';

export const getPaginationConfig = (
  total: number,
  rowsPerPage: number,
  page: number,
  onPageChange: (
    event: MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void,
  onRowsPerPageChange: ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  >,
  sxProps?: SxProps<Theme>
): TablePaginationTypeMap<Record<string, unknown>, ElementType> => {
  const from = page * rowsPerPage + 1;
  const to = page * rowsPerPage + rowsPerPage;

  return {
    props: {
      rowsPerPageOptions: [
        10,
        25,
        50,
        {
          label: 'All',
          value: total,
        },
      ],
      count: total,
      rowsPerPage: rowsPerPage,
      page: page,
      showFirstButton: true,
      showLastButton: true,
      labelRowsPerPage: 'Items per page',
      labelDisplayedRows: () =>
        `${from} - ${to > total ? total : to} out of ${total}`,
      SelectProps: {
        inputProps: {
          'aria-label': 'rows per page',
        },
        native: false,
      },
      onPageChange: onPageChange,
      onRowsPerPageChange: onRowsPerPageChange,
      ActionsComponent: TableActions,
      sx: sxProps,
    },
    defaultComponent: null as unknown as ElementType,
  };
};
